import React from "react";
import "../../auth.css";
import logo from "../../../../assets/Logo/acte_masterclass_logo_dark.png";
import LanguageContentSection from "../../common/LanguageContentSection";
import OtpVerifyContentForm from "./OtpVerifyContentForm";

const OtpVerifyContentSection = () => {
    return (
        <>
            {/* Otp Verification content section start */}
            <div className="login-content-section">
                {/* Otp Verification content form start */}
                <div className="login-content-form mt-4">
                    <div className="login-catapult-logo">
                        <img src={logo} alt="Website Logo" className="logo-image" />
                    </div>
                    <div className="login-form otp-verification-form">
                        <OtpVerifyContentForm />
                    </div>
                </div>
                {/* Otp Verification content form end */}

                {/* footer start */}
                <div className="login-footer login-footer-otp">
                    <div className="login-footer-spacer"></div>
                    <div className="login-language-section">
                        <LanguageContentSection />
                    </div>
                </div>
                {/* footer end */}
            </div>
            {/* Otp Verification content section end */}
        </>
    );
};

export default OtpVerifyContentSection;
